
import React from "react";
import LessonMaterialsList from "@/components/lessons/LessonMaterialsList";

interface LessonMaterialDisplayProps {
  lessonMaterials: Array<{
    id: string;
    title: string;
    url: string;
    type: string;
  }>;
  courseMaterials?: Array<{
    id: string;
    title: string;
    url: string;
    type: string;
  }>;
}

const LessonMaterialDisplay = ({ 
  lessonMaterials,
  courseMaterials = []
}: LessonMaterialDisplayProps) => {
  const allMaterials = [...lessonMaterials, ...courseMaterials];
  
  if (allMaterials.length === 0) {
    return null;
  }

  return <LessonMaterialsList materials={allMaterials} />;
};

export default LessonMaterialDisplay;
